import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { SuperAdminAddConversionForm } from '../../../presentation-components/super-admin/super-admin-add-conversion-form';
import { SuperAdminSecrMappingCard } from '../../../presentation-components/super-admin/super-admin-secr-mapping-card';
import ConversionFactorCustomService from '../../../../shared/services/conversion-factor-custom/conversion-factor-custom-service';
import { IConversionFactorCustom, IPostConversionFactorCustom } from '../../../../shared/services/conversion-factor-custom/conversion-factor-custom.model';

export const SuperAdminEditConversionFactorPage = () => {
  const { conversionSourceId, conversionFactorCustomId } = useParams();
  //Services
  const conversionFactorCustomService = new ConversionFactorCustomService();
  //Context
  const userNotificationsContext = useContext(UserNotificationsContext);
  //State
  const [newConversion, setNewConversion] = useState<IConversionFactorCustom>();
  const [editField, setEditField] = useState<string>('');
  //Loading State
  const [isFormSubmitting, setIsFormSubmitting] = useState<boolean>(false);

  useEffect(() => {
    if (conversionFactorCustomId) {
      getConversionFactorCustom(conversionFactorCustomId!)
    }
  }, [conversionFactorCustomId]);

  const getConversionFactorCustom = (id: string) => {
    conversionFactorCustomService.getOne(id)
      .then((response) => {
        setNewConversion(response);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const submitHandler = (values: IPostConversionFactorCustom) => {
    setIsFormSubmitting(true);
    conversionFactorCustomService.edit(conversionFactorCustomId!, values)
      .then((response) => {
        setIsFormSubmitting(false);
        userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' });
        getConversionFactorCustom(conversionFactorCustomId!);
        setEditField('');
      })
      .catch((err) => {
        setIsFormSubmitting(false);
        console.log(err);
        setEditField('');
        userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
      });
  }

  return (
    <PageOuterContainer>
      <PageHeading
        title='Edit Conversion Factor'
        includeBackButton={true}
        backButtonLink={`/super-admin/conversion-factors/${conversionSourceId}`}
        backButtonText='Back to Conversion Factors'
      />
      {conversionSourceId && newConversion && (
        <>
          <SuperAdminAddConversionForm
            newConversion={{
              detailLevelOne: newConversion.detailLevelOne,
              detailLevelTwo: newConversion.detailLevelTwo,
              detailLevelThree: newConversion.detailLevelThree,
              measurementUnitId: newConversion.measurementUnitId,
              greenHouseGasUnitId: newConversion.greenHouseGasUnitId,
              multiplier: newConversion.multiplier,
              categoryId: newConversion.categoryId,
              scope: newConversion.scope,
              conversionSourceId: conversionSourceId!,
              isRenewable: newConversion.isRenewable,
            }}
            isSubmitting={isFormSubmitting}
            conversionSourceId={conversionSourceId}
            submitHandler={submitHandler}
            isEditPage={true}
            editField={editField}
            setEditField={setEditField}
          />
          <SuperAdminSecrMappingCard
            factorId={conversionFactorCustomId!}
            suggestedKey={newConversion.secrSourceSuggestedKey}
            secrSourceKey={newConversion.secrSourceKey}
            status={newConversion.secrSourceMappingStatus}
            onSaved={() => getConversionFactorCustom(conversionFactorCustomId!)}
          />
        </>
      )}
    </PageOuterContainer>
  );
}

